import dynamic from 'next/dynamic';
import SectionA1 from '../../DeltaProUltra/Launch/Detail/components/SectionA1';
import SectionA2 from '../../DeltaProUltra/Launch/Detail/components/SectionA2';
import SectionA3 from '../../DeltaProUltra/Launch/Detail/components/SectionA3';
import SectionA4 from '../../DeltaProUltra/Launch/Detail/components/SectionA4';
import SectionA5 from '../../DeltaProUltra/Launch/Detail/components/SectionA5';
import SectionA6 from '../../DeltaProUltra/Launch/Detail/components/SectionA6';
import SectionA7 from '../../DeltaProUltra/Launch/Detail/components/SectionA7';
import SectionA8 from '../../DeltaProUltra/Launch/Detail/components/SectionA8';
import SectionCarousel from '../../DeltaProUltra/Launch/Detail/components/SectionCarousel';
import SectionPhone from '../../DeltaProUltra/Launch/Detail/components/SectionPhone';
import SectionVideo from '../../DeltaProUltra/Launch/Detail/components/SectionVideo';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import FixProcess from './components/FixProcess';
import G from './components/G';
import I from './components/I';
import J from './components/J';
import M from './components/M';
import N from './components/N';
import NA2 from './components/NA2';
import NEW1 from './components/NEW1';
import NEW2 from './components/NEW2';
import O from './components/O';
import OASIS1 from './components/OASIS1';
import OASIS2 from './components/OASIS2';
import OASIS3 from './components/OASIS3';
import OASIS4 from './components/OASIS4';
import P from './components/P';
import Q from './components/Q';
import R from './components/R';
import SHP2B from './components/SHP2B';
import SHP2C from './components/SHP2C';
import SHP2D from './components/SHP2D';
import SHP2E from './components/SHP2E';
import SHP2G from './components/SHP2G';
import SHP2K from './components/SHP2K';
import T from './components/T';
import U from './components/U';
import V from './components/V';
import W from './components/W';
import X from './components/X';
import BUs from './componentsUs/B';
import CutCosts from './componentsUs/CutCosts';
import ECOMode from './componentsUs/ECOMode';
import EnergyBackup from './componentsUs/EnergyBackup';
import IUs from './componentsUs/I';
import NEW1Us from './componentsUs/NEW1Us';
import OASIS4US from './componentsUs/OASIS4';
import OEu from './componentsUs/OEu';
import PowerBackup from './componentsUs/PowerBackup';
import PowerBackup2 from './componentsUs/PowerBackup2';
import SeamlessTransition from './componentsUs/SeamlessTransition';
import Section from './componentsUs/Section';
import SectionCard from './componentsUs/SectionCard';
import SOC from './componentsUs/SOC';
import StormPrep from './componentsUs/StormPrep';
import UltraSavings from './componentsUs/UltraSavings';
import { useGlobal } from '@/utils/useGlobal';

const AU_Template = dynamic(() => import('./componentsAU'), {
    ssr: false,
});

export default function IndexDynamic() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    if (locale === 'us') {
        return (
            <>
                <FixProcess />
                <div className="range1">
                    <BUs />
                    <D />
                    <G />
                    <E />
                    <NA2 />
                </div>
                <div className="range2">
                    <EnergyBackup />
                    <StormPrep />
                    <SeamlessTransition />
                    <PowerBackup />
                </div>
                <div className="range3">
                    <UltraSavings />
                    <IUs />
                    <OASIS4US />
                    {/* <TimedCircuits /> */}
                    <Section />
                    <ECOMode />
                    <PowerBackup2 />
                </div>
                <div className="range4">
                    <CutCosts />
                    <NEW1Us />
                    <R />
                    <U />
                    <SectionCard />
                </div>
                <div className="range5">
                    <OEu />
                    <SOC />
                    <P />
                    <Q />
                    <V />
                    <W />
                </div>
                <X />
            </>
        );
    } else if (locale === 'ca') {
        return (
            <>
                <FixProcess />
                <div className="range1">
                    <B />
                    <C />
                    <D />
                    <E />
                    <G />
                    <NA2 />
                    <J />
                    <I />
                    <SHP2C />
                    <SHP2B />
                    <SHP2D />
                    <N />
                    <SHP2E />
                </div>
                <div className="range2">
                    <SHP2G />
                    <OASIS1 />
                    <OASIS2 />
                    <OASIS3 />
                    <OASIS4 />
                </div>
                <div className="range3">
                    <SHP2K />
                    <NEW1 />
                    <R />
                    <U />
                </div>
                <div className="range4">
                    <O />
                    <P />
                    <Q />
                    {/* <H /> */}
                    {/* <M /> */}
                    <T />
                    <NEW2 />
                    <V />
                    <W />
                </div>
                <X />
            </>
        );
    } else if (['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale)) {
        return (
            <>
                <SectionA6 />
                <SectionCarousel />
                <D />
                <E />
                {/* <G /> */}
                <SectionA7 />
                <SectionA1 />
                <SectionA8 />
                <></>
                <SectionVideo />
                <SectionPhone />

                {/* <I /> */}
                {/* <OASIS1 /> */}
                <SectionA2 />
                <SectionA3 />
                <M />
                <O />
                <P />
                <Q />
                <SectionA4 />
                <SectionA5 />
            </>
        );
    } else if (locale === 'au') {
        return <AU_Template />;
    }
}
